import { db } from "../firebase-config";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";

export const addBug = async (bug) => {
    try {
        await addDoc(collection(db, "bug_reports"), {
            ...bug,
            created_at: serverTimestamp()  // Optionally add a timestamp for when the bug report is created
        });
        return { success: true, error: null };
    } catch (error) {
        console.error("Error submitting bug report:", error);
        return { success: false, error: error.message || 'Bug report failed to submit' };
    }
};
